import './../../index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const TinkoffGrayscaleSize24Component = (props, ref) => (jsxs("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: [jsx("path", { d: "M1 1H23V12.0642C23 14.9008 21.4854 17.5225 19.0306 18.9408L12 23L4.96937 18.9408C2.51138 17.5225 1 14.9008 1 12.0642V1Z", fill: "#C6C6C6" }), jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.03617 6.82422V10.2641C7.50787 9.73145 8.36143 9.37206 9.34013 9.37206H10.4023V13.3735C10.4023 14.4389 10.1135 15.3694 9.68348 15.8829H14.3075C13.8807 15.3694 13.5919 14.4389 13.5919 13.3767V9.37527H14.654C15.6327 9.37527 16.4895 9.73466 16.958 10.2673V6.82743H7.03296L7.03617 6.82422Z", fill: "#919191" })] }));
const TinkoffGrayscaleSize24 = hoc(forwardRef(TinkoffGrayscaleSize24Component), 'TinkoffGrayscaleSize24');

export { TinkoffGrayscaleSize24 as default };
//# sourceMappingURL=TinkoffGrayscaleSize24.js.map
